import "./EmployeeAssignemntStyle.css";

import {
	BackdropCircularProgress,
	DeleteConfirmationDialog,
	EnhancedSnackbar,
	IResponse,
	IServerError,
	SingleColumnLayout,
	StandardPanel,
} from "@websential/cosmic-v20";
import { Box, Button, Card, Grid, Typography, useTheme } from "@mui/material";
import {
	EMPLOYEE_STATUS_SETUP_SCREEN_SLUG,
	INITIAL_PAGE_SIZE,
	INITIAL_SNACKBAR_DATA,
	ROWS_PER_PAGE_PER_OPTIONS,
} from "../../common/constants";
import { FormProvider, useForm } from "react-hook-form";
import { Link, useNavigate, useParams } from "react-router-dom";
import React, { useEffect, useMemo, useState } from "react";
import { TabPanel, TabView } from "primereact/tabview";
import { formatDate, sortDDLByLabel, sortData, useNavigateToLogout } from "../../common/Common";
import {
	setSelectedActivityLogActions,
	setSelectedStickyNavBar,
} from "../../store/actions";
import { useDispatch, useSelector } from "react-redux";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { Avatar } from "primereact/avatar";
import { DDLDataTable } from "../DDLDataTable";
import { DepartmentsService } from "../../services/DepartmentsService";
import { DepartmentsTabsPanel } from "./Panels/Tabs/Department/DepartmentTabsPanel";
import { DesignationsTabsPanel } from "./Panels/Tabs/Designations/DesignationsTabsPanel";
import { Divider } from "primereact/divider";
import { EmployeeAssignemntToolbar } from "./EmployeeAssignemntToolbar";
import { EmployeeAssignemntValidationSchema } from "./validator";
import { EmployeeService } from "../../services/EmployeeService";
import { ExpenseCategoryTabsPanel } from "./Panels/Tabs/ExpenseCategory/ExpenseCategoryTabsPanel";
import { IAppState } from "../../store/reducers";
import { InputText } from "primereact/inputtext";
import { LocationsTabsPanel } from "./Panels/Tabs/Locations/LocationsTabsPanel";
import { TeamsTabsPanel } from "./Panels/Tabs/Teams/TeamsTabsPanel";
import { setSelectedDrawerOptionsMenu } from "../../store/actions/drawerMenuOptionsActions";
import { yupResolver } from "@hookform/resolvers/yup";

// import { SingleColumnLayout } from "./SingleColumnLayout";

export interface IEmployeeAssignemnt { }
const SINGLE_RECORD_DATA_QUERY_KEY = "employee-single-data-record";

const useGetData = (
	employeeId: any,
	clientId: string,
	desisgnLabel: string | number,
	navigateToLogout: (path: string) => void
) =>
	useQuery({
		queryKey: [
			SINGLE_RECORD_DATA_QUERY_KEY,
			employeeId,
			clientId,
			desisgnLabel,
		],
		queryFn: () => {
			return EmployeeService.getEmployeeAssignemntData(
				employeeId,
				clientId,
				desisgnLabel,
				navigateToLogout
			);
		},
		refetchOnWindowFocus: false,
	});

const useGetEmployeeDDL = (clientId: string) =>
	useQuery({
		queryKey: ["employee-status-ddl", clientId],
		queryFn: () => {
			return EmployeeService.getEmployeeDDL(clientId);
		},
		refetchOnWindowFocus: false,
	});
const useGetDepartmentsDDL = (clientId: string) =>
	useQuery({
		queryKey: ["department-ddl", clientId],
		queryFn: () => {
			return DepartmentsService.getGetDepartmentsDDL(clientId);
		},
		refetchOnWindowFocus: false,
	});

export let designationsInitialData = [
	{
		id: "1",
		designations: "",
		fromDate: null,
		toDate: null,
		notes: "",
		rowWithRandomId: true
	},
	{
		id: "2",
		designations: "",
		fromDate: null,
		toDate: null,
		notes: "",
		rowWithRandomId: true
	},
	{
		id: "3",
		designations: "",
		fromDate: null,
		toDate: null,
		notes: "",
		rowWithRandomId: true
	},
	{
		id: "4",
		designations: "",
		fromDate: null,
		toDate: null,
		notes: "",
		rowWithRandomId: true
	},
	{
		id: "5",
		designations: "",
		fromDate: null,
		toDate: null,
		notes: "",
		rowWithRandomId: true
	},
];

export const departmentsInitialData = designationsInitialData.map(
	({ designations, ...rest }: any) => ({
		...rest,
		departments: "", // Replace designations with departments
	})
);
export const locationsInitialData = designationsInitialData.map(
	({ designations, ...rest }: any) => ({
		...rest,
		locations: "", // Replace designations with locations
	})
);
export const teamsInitialData = designationsInitialData.map(
	({ designations, ...rest }: any) => ({
		...rest,
		teams: "", // Replace designations with teams
	})
);
export const expenseCategoryInitialData = designationsInitialData.map(
	({ designations, ...rest }: any) => ({
		...rest,
		expenseCategory: "", // Replace designations with expenseCategory
	})
);

export const EmployeeAssignemnt: React.FC<IEmployeeAssignemnt> = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const theme = useTheme();

	const drawerMenuOptions = useSelector(
		(state: IAppState) => state.drawerMenu.menu
	);
	const [isLoadingData, setIsLoadingData] = useState(false);

	const [openDialog, setDialogOpen] = useState(false);
	const [singleDelete, setSingleDelete] = useState<boolean>(false);
	const [itemSearch, setItemSearch] = useState("");
	const [activeTabIndex, setActiveTabIndex] = useState(0);
	const [activeTabLabel, setActiveTabLabel] = useState("Departments");
	// const [departmentsData, setDepartmentsData] = useState(
	// 	departmentsInitialData
	// );
	const [departmentsUpdatedData, setdepartmentsUpdatedData] = useState(
		departmentsInitialData
	);
	const [departmentsDataItems, setdepartmentsDataItems] = useState(
		departmentsInitialData
	);
	// const [designationsData, setDesignationsData] = useState(
	// 	designationsInitialData
	// );
	const [designationsUpdatedData, setdesignationsUpdatedData] = useState(
		designationsInitialData
	);
	const [designationsDataItems, setdesignationsDataItems] = useState(
		designationsInitialData
	);
	// const [teamsData, setTeamsData] = useState(teamsInitialData);
	const [teamsUpdatedData, setteamsUpdatedData] = useState(teamsInitialData);
	const [teamsDataItems, setteamsDataItems] = useState(teamsInitialData);
	// const [locationsData, setLocationsData] = useState(locationsInitialData);
	const [locationsUpdatedData, setlocationsUpdatedData] =
		useState(locationsInitialData);
	const [locationsDataItems, setlocationsDataItems] =
		useState(locationsInitialData);
	// const [expenseCategoryData, setExpenseCategoryData] = useState(
	// 	expenseCategoryInitialData
	// );
	const [expenseCategoryUpdatedData, setexpenseCategoryUpdatedData] = useState(
		expenseCategoryInitialData
	);
	const [expenseCategoryDataItems, setexpenseCategoryDataItems] = useState(
		expenseCategoryInitialData
	);

	const [sidePanelsVisibility, setSidePanelsVisibility] = useState(true);
	const [selectedCard, setSelectedCard] = useState<any>(null);
	const [selectedEmployeeId, setSelectedEmployeeId] = useState<any>(undefined);
	const [deletedRowId, setDeletedRowId] = useState<any>(undefined);
	const [selectedEmployeeLabel, setSelectedEmployeeLabel] = useState("");
	const [employeeAssignemntsList, setEmployeeAssignemntsList] =
		useState<any>(undefined);
	const accountantId = useSelector((state: IAppState) => state.accountant.id);
	const clientId = useSelector((state: IAppState) => state.client.id);
	const [deleteAssignEmployeeId, setDeleteAssignEmployeeId] = useState<number>(0);
	const [snackbarData, setSnackbarData] = useState(INITIAL_SNACKBAR_DATA);
	const queryClient = useQueryClient();
	const isAdminUser = useSelector(
		(state: IAppState) => state.user.profile.isSuperStatus
	);
	const navigateToLogout = useNavigateToLogout();
	const { id } = useParams();

	const [editRecordId, setEditRecordId] = useState(id);
	const [isPendingData, setIsPendingData] = useState(false);

	const TabTableheaderColumns = [
		{
			field: "label",
			headerName: "",
			description: "",
			flex: 1,
			hide: false,
			hideable: false,
			sortable: true,
			sortingOrder: "asc",
			resizable: false,
			type: "string",
			align: "left",
			headerAlign: "center",
			hideSortIcons: false,
			disableColumnMenu: true,
			disableReorder: true,
			disableExport: true,
			maskable: false,
			isFixed: true,
			sequence: 0,
			frozenColumn: false,
			footer: null,
		},
		{
			field: `${activeTabLabel
				.toLowerCase()
				.replace(/\s+(.)/g, (_, char) => char.toUpperCase())
				.replace(/\s+/g, "")}`,
			headerName: `${activeTabLabel}`,
			description: "",
			flex: 1,
			hide: false,
			hideable: false,
			sortable: true,
			sortingOrder: "asc",
			resizable: false,
			type: "string",
			align: "left",
			headerAlign: "center",
			hideSortIcons: false,
			disableColumnMenu: true,
			disableReorder: true,
			disableExport: true,
			maskable: false,
			isFixed: true,
			sequence: 0,
			frozenColumn: false,
			footer: null,
		},
		{
			field: "fromDate",
			headerName: "From Date",
			description: "",
			flex: 1,
			hide: false,
			hideable: false,
			sortable: true,
			sortingOrder: "asc",
			resizable: false,
			type: "string",
			align: "left",
			headerAlign: "center",
			minWidth: "12rem",
			hideSortIcons: false,
			disableColumnMenu: true,
			disableReorder: true,
			disableExport: true,
			maskable: false,
			isFixed: true,
			sequence: 1,
			frozenColumn: false,
			footer: null,
		},
		{
			field: "toDate",
			headerName: "To Date",
			description: "",
			flex: 1,
			hide: false,
			hideable: false,
			sortable: true,
			sortingOrder: "asc",
			resizable: false,
			type: "string",
			align: "left",
			headerAlign: "center",
			minWidth: "12rem",
			maxWidth: "12rem",
			hideSortIcons: false,
			disableColumnMenu: true,
			disableReorder: true,
			disableExport: true,
			maskable: false,
			isFixed: true,
			sequence: 2,
			frozenColumn: false,
			footer: null,
		},
		{
			field: "notes",
			headerName: "Notes",
			description: "",
			flex: 1,
			hide: false,
			hideable: false,
			sortable: true,
			sortingOrder: "asc",
			resizable: false,
			type: "string",
			align: "left",
			headerAlign: "center",
			hideSortIcons: false,
			disableColumnMenu: true,
			disableReorder: true,
			disableExport: true,
			maskable: false,
			isFixed: true,
			sequence: 3,
			frozenColumn: false,
			footer: null,
		},
	];

	const {
		isPending: isSubmitting,
		mutate: submitEmployeeAssignemntFormFields,
	} = useMutation({
		mutationFn: EmployeeService.createEmployeeAssignemnt,
		onSuccess: (res: IEmployeeAssignemnt | IServerError | IResponse | any) => {

			if (res.status === 200) {
				// if (instanceOfIEmployeeResponse(res)) {
				setEditRecordId(res.data.employeeId);
				setSnackbarData({
					open: true,
					message: "Success",
					severity: "success",
				});

				let path = `/employee/assignment/${res.data.employeeId}`;
				navigate(path);
				queryClient.invalidateQueries({
					queryKey: [SINGLE_RECORD_DATA_QUERY_KEY],
				});
			} else if (res.status === 201) {
				setEditRecordId(res.data.employeeId);
				setSnackbarData({
					open: true,
					message: "Success",
					severity: "success",
				});
				let path = `/employee/assignment/${res.data.employeeId}`;
				navigate(path);
				queryClient.invalidateQueries({
					queryKey: [SINGLE_RECORD_DATA_QUERY_KEY],
				});
			} else {
				setSnackbarData({
					open: true,
					message: res.message ? res.message : "Something went wrong!",
					severity: "error",
				});
			}
		},
		onError: () => {
			// TODO: customize the toast message based on the response
			setSnackbarData({
				open: true,
				message: "Something went wrong, try again later!",
				severity: "error",
			});
		},
	});

	const formMethods = useForm<any>({
		resolver: yupResolver(EmployeeAssignemntValidationSchema),
		mode: "onBlur",
		reValidateMode: "onChange",
	});

	const { data: selectedDataRecord, isPending } = useGetData(
		// selectedEmployeeId,
		editRecordId,
		clientId,
		// activeTabLabel,
		activeTabIndex === 0
			? 200
			: activeTabIndex === 1
				? 300
				: activeTabIndex === 2
					? 400
					: activeTabIndex === 3
						? 100
						: 500,
		navigateToLogout
	);

	const {
		data: employeeAssignemntLabelsList,
		isPending: isPendingEmployeeDDL,
	} = useGetEmployeeDDL(clientId);

	useEffect(() => {

		if (Array.isArray(employeeAssignemntLabelsList)) {
			setEmployeeAssignemntsList(sortData(employeeAssignemntLabelsList));
		}
	}, [employeeAssignemntLabelsList]);

	// const filteredList =
	// 	employeeAssignemntsList &&
	// 	employeeAssignemntsList.filter((item: any) =>
	// 		item.label.toLowerCase().includes(itemSearch.toLowerCase())
	// 	);

	const onEmployeeClickedHandler = async (selectedItem: any): Promise<void> => {

		setSelectedEmployeeId(selectedItem.value);
		setSelectedEmployeeLabel(selectedItem.label);
		setEditRecordId(selectedItem.value);
	};

	const upadtedEmployeeAssignmentItems = useMemo(() => {
		return (
			employeeAssignemntsList &&
			sortDDLByLabel(employeeAssignemntsList).map((item: any) => ({
				...item,
				label: (
					<Link
						to={`/employee/assignment/${item.value}`}
						// to={`/employee/assignment`}
						className="no-underline"
						style={{ color: theme.palette.primary.light }}
						// onClick={() => setEditRecordId(item.value)}
						onClick={() => onEmployeeClickedHandler(item)}
					>
						{item.label}
					</Link>
				),
				// id:item.value
			}))
		);
	}, [employeeAssignemntsList]);

	const { data: departmentsDDL, isPending: isPendingDepartmentDDL } =
		useGetDepartmentsDDL(clientId);
	const departmentsDDLItems = useMemo(() => {
		if (departmentsDDL && Array.isArray(departmentsDDL)) {
			let resources: any[] = sortDDLByLabel(departmentsDDL).map((resourceItem: any) => ({
				id: resourceItem.value,
				label: resourceItem.label,
				value: resourceItem.value,
			}));
			resources.unshift({
				label: "--",
				value: null,
			});
			return resources;
		} else if (departmentsDDL) {
			return [
				{
					label: "--",
					value: null,
				},
			];
		}
	}, [departmentsDDL]);

	let activeTab = activeTabLabel
		.toLowerCase()
		.replace(/\s+(.)/g, (_, char) => char.toUpperCase())
		.replace(/\s+/g, "");

	const onSubmit = (values: any) => {

		if (selectedEmployeeId) {
			// const invalidDepartmentsItems = departmentsUpdatedData
			// 	.filter(
			// 		(item: any) => item.departments !== "" && item.fromDate === null
			// 	)
			// 	.map((item: any) => item.departments);
			// const invalidDesignationsItems = designationsUpdatedData
			// 	.filter(
			// 		(item: any) => item.designations !== "" && item.fromDate === null
			// 	)
			// 	.map((item: any) => item.designations);
			// const invalidTeamsItems = teamsUpdatedData
			// 	.filter((item: any) => item.teams !== "" && item.fromDate === null)
			// 	.map((item: any) => item.teams);
			// const invalidLocationsItems = locationsUpdatedData
			// 	.filter((item: any) => item.locations !== "" && item.fromDate === null)
			// 	.map((item: any) => item.locations);
			// const invalidExpenseCategoryItems = expenseCategoryUpdatedData
			// 	.filter(
			// 		(item: any) => item.expenseCategory !== "" && item.fromDate === null
			// 	)
			// 	.map((item: any) => item.expenseCategory);
			// if (invalidDepartmentsItems.length > 0) {
			// 	setSnackbarData({
			// 		open: true,
			// 		message: `Please select From Date of added Departments`,
			// 		severity: "error",
			// 	});
			// } else if (invalidDesignationsItems.length > 0) {
			// 	setSnackbarData({
			// 		open: true,
			// 		message: `Please select From Date of added Designations`,
			// 		severity: "error",
			// 	});
			// } else if (invalidTeamsItems.length > 0) {
			// 	setSnackbarData({
			// 		open: true,
			// 		message: `Please select From Date of added Teams`,
			// 		severity: "error",
			// 	});
			// } else if (invalidLocationsItems.length > 0) {
			// 	setSnackbarData({
			// 		open: true,
			// 		message: `Please select From Date of added Locations`,
			// 		severity: "error",
			// 	});
			// } else if (invalidExpenseCategoryItems.length > 0) {
			// 	setSnackbarData({
			// 		open: true,
			// 		message: `Please select From Date of added Expense Categories`,
			// 		severity: "error",
			// 	});
			// } else {
			const itemsWithDepartmentAndDate = departmentsUpdatedData.filter(
				(item: any) => item.departments !== null && item.fromDate !== null
			);
			const isValidDepartments = itemsWithDepartmentAndDate.every((item: any) => {
				const hasDate = item.fromDate !== null;
				const hasDepartment = item.departments !== null;
				return (!hasDate || hasDepartment) && (!hasDepartment || hasDate);
			});


			const itemsWithDesignationsAndDate = designationsUpdatedData.filter(
				(item: any) => item.designations !== null && item.fromDate !== null
			);
			const isValidDesignations = itemsWithDesignationsAndDate.every(
				(item) => {
					const hasDate = item.fromDate !== null;
					const hasDesignations = item.designations !== null;
					return (!hasDate || hasDesignations) && (!hasDesignations || hasDate);
				});


			const itemsWithTeamsAndDate = teamsUpdatedData.filter(
				(item: any) => item.teams !== null && item.fromDate !== null
			);
			const isValidTeams = itemsWithTeamsAndDate.every(
				(item) => {
					const hasDate = item.fromDate !== null;
					const hasTeams = item.teams !== null;
					return (!hasDate || hasTeams) && (!hasTeams || hasDate);
				});



			const itemsWithLocationsAndDate = locationsUpdatedData.filter(
				(item: any) => item.locations !== null && item.fromDate !== null
			);
			const isValidLocations = itemsWithLocationsAndDate.every(
				(item) => {
					const hasDate = item.fromDate !== null;
					const hasLocations = item.locations !== null;
					return (!hasDate || hasLocations) && (!hasLocations || hasDate);
				});



			const itemsWithExpenseCategoryAndDate = expenseCategoryUpdatedData.filter(
				(item: any) => item.expenseCategory !== null && item.fromDate !== null
			);
			const isValidExpenseCategory = itemsWithExpenseCategoryAndDate.every(
				(item) => {
					const hasDate = item.fromDate !== null;
					const hasExpenseCategory = item.expenseCategory !== null;
					return (!hasDate || hasExpenseCategory) && (!hasExpenseCategory || hasDate);
				});


			if (!isValidDepartments && activeTab === "departments") {
				setSnackbarData({
					open: true,
					// message: `Please select From Date of ${invalidDepartmentsItems.join(", ")} departments`,
					message: `Departments : Required field data missing!`,
					severity: "error",
				});
			} else if (!isValidDesignations && activeTab === "designations") {
				setSnackbarData({
					open: true,
					message: "Designations : Required field data missing!",
					severity: "error",
				});
			} else if (!isValidTeams && activeTab === "teams") {
				setSnackbarData({
					open: true,
					message: "Teams : Required field data missing!",
					severity: "error",
				});
			} else if (!isValidLocations && activeTab === "locations") {
				setSnackbarData({
					open: true,
					message: "Locations : Required field data missing!",
					severity: "error",
				});
			} else if (!isValidExpenseCategory && activeTab === "expenseCategory") {
				setSnackbarData({
					open: true,
					message: "Expense Category : Required field data missing!",
					severity: "error",
				});
			} else {
				const formattedDepartmentsData = itemsWithDepartmentAndDate
					.filter(
						(item: any) =>
							item.departments !== "" && item.departments?.label !== "--"
					)
					.map((item: any) => ({
						...item,
						id: item.id && item.id.length > 20 ? item.id : undefined,
						clientId: clientId,
						employeeId: selectedEmployeeId,
						companyDesignId: item.departments,
						designLabel: 200,
						fromDate:
							item.fromDate && item.fromDate !== "" && item.fromDate !== null
								? formatDate(item.fromDate)
								: null,
						toDate:
							item.toDate && item.toDate !== "" && item.toDate !== null
								? formatDate(item.toDate)
								: null,
					}));



				const formattedDesignationsData = itemsWithDesignationsAndDate
					.filter(
						(item: any) =>
							item.designations !== "" && item.designations?.label !== "--"
					)
					.map((item: any) => ({
						...item,
						id: item.id && item.id.length > 20 ? item.id : undefined,
						clientId: clientId,
						employeeId: selectedEmployeeId,
						companyDesignId: item.designations,
						designLabel: 300,
						fromDate:
							item.fromDate && item.fromDate !== "" && item.fromDate !== null
								? formatDate(item.fromDate)
								: null,
						toDate:
							item.toDate && item.toDate !== "" && item.toDate !== null
								? formatDate(item.toDate)
								: null,
					}));



				const formattedTeamsData = itemsWithTeamsAndDate
					.filter(
						(item: any) => item.teams !== "" && item.teams?.label !== "--"
					)
					.map((item: any) => ({
						...item,
						id: item.id && item.id.length > 20 ? item.id : undefined,
						clientId: clientId,
						employeeId: selectedEmployeeId,
						companyDesignId: item.teams,
						designLabel: 400,
						fromDate:
							item.fromDate && item.fromDate !== "" && item.fromDate !== null
								? formatDate(item.fromDate)
								: null,
						toDate:
							item.toDate && item.toDate !== "" && item.toDate !== null
								? formatDate(item.toDate)
								: null,
					}));



				const formattedLocationsData = itemsWithLocationsAndDate
					.filter(
						(item: any) =>
							item.locations !== "" && item.locations?.label !== "--"
					)
					.map((item: any) => ({
						...item,
						id: item.id && item.id.length > 20 ? item.id : undefined,
						clientId: clientId,
						employeeId: selectedEmployeeId,
						companyDesignId: item.locations,
						designLabel: 100,
						fromDate:
							item.fromDate && item.fromDate !== "" && item.fromDate !== null
								? formatDate(item.fromDate)
								: null,
						toDate:
							item.toDate && item.toDate !== "" && item.toDate !== null
								? formatDate(item.toDate)
								: null,
					}));



				const formattedExpenseCategoryData = itemsWithExpenseCategoryAndDate
					.filter(
						(item: any) =>
							item.expenseCategory !== "" &&
							item.expenseCategory?.label !== "--"
					)
					.map((item: any) => ({
						...item,
						id: item.id && item.id.length > 20 ? item.id : undefined,
						clientId: clientId,
						employeeId: selectedEmployeeId,
						companyDesignId: item.expenseCategory,
						designLabel: 500,
						fromDate:
							item.fromDate && item.fromDate !== "" && item.fromDate !== null
								? formatDate(item.fromDate)
								: null,
						toDate:
							item.toDate && item.toDate !== "" && item.toDate !== null
								? formatDate(item.toDate)
								: null,
					}));



				console.log('formattedDepartmentsData', formattedDepartmentsData)

				if (
					(activeTab === "departments" && formattedDepartmentsData.length === 0) ||
					(activeTab === "designations" && formattedDesignationsData.length === 0) ||
					(activeTab === "teams" && formattedTeamsData.length === 0) ||
					(activeTab === "locations" && formattedLocationsData.length === 0) ||
					(activeTab === "expenseCategory" && formattedExpenseCategoryData.length === 0)
				) {
					setSnackbarData({
						open: true,
						message: "Please add data to save!",
						severity: "error"
					})
				} else {
					let payload = {
						navigateToLogout: navigateToLogout,
						clientId: clientId,
						// id: selectedDataRecord && selectedDataRecord.id,
						employeeId: selectedEmployeeId,
						employeeName: selectedEmployeeLabel,
						// id: id && id,
						items:
							activeTab === "departments"
								? { items: formattedDepartmentsData }
								: activeTab === "designations"
									? { items: formattedDesignationsData }
									: activeTab === "teams"
										? { items: formattedTeamsData }
										: activeTab === "locations"
											? { items: formattedLocationsData }
											: activeTab === "expenseCategory"
												? { items: formattedExpenseCategoryData }
												: { items: [] },
						// employeeId: selectedEmployeeId,
						// departments: formattedDepartmentsData,
						// designations: formattedDesignationsData,
						// teams: formattedTeamsData,
						// locations: formattedLocationsData,
						// expenseCategory: formattedExpenseCategoryData,
					};
					submitEmployeeAssignemntFormFields(payload);
					// console.log("payloaddddd",payload)
				}
			}
		} else {
			setSnackbarData({
				open: true,
				message: "Please Select Employee.",
				severity: "warning",
			});
		}
	};

	useEffect(() => {
		if (selectedDataRecord && selectedDataRecord?.items.length === 0) {
			// setDepartmentsData(departmentsInitialData);
			setdepartmentsDataItems(departmentsInitialData);
			setdesignationsDataItems(designationsInitialData);
			setteamsDataItems(teamsInitialData);
			setlocationsDataItems(locationsInitialData);
			setexpenseCategoryDataItems(expenseCategoryInitialData);
		} else if (selectedDataRecord) {

			// setSelectedEmployeeLabel(selectedDataRecord.employeeName);
			if (activeTab === "departments") {
				const formattedDepartmentsData = selectedDataRecord.items.map(
					(item: any) => ({
						id: item.id,
						departments: item.companyDesignId,
						fromDate:
							item.fromDate && item.fromDate !== "" && item.fromDate !== null
								? new Date(item.fromDate)
								: null,
						toDate:
							item.toDate && item.toDate !== "" && item.toDate !== null
								? new Date(item.toDate)
								: null,
						notes: item.notes,
					})
				);

				// setDepartmentsData(formattedDepartmentsData);
				setdepartmentsDataItems(formattedDepartmentsData);
			} else if (activeTab === "designations") {
				const formattedDesignationsData = selectedDataRecord.items.map(
					(item: any) => ({
						id: item.id,
						designations: item.companyDesignId,
						fromDate:
							item.fromDate && item.fromDate !== "" && item.fromDate !== null
								? new Date(item.fromDate)
								: null,
						toDate:
							item.toDate && item.toDate !== "" && item.toDate !== null
								? new Date(item.toDate)
								: null,
						notes: item.notes,
					})
				);
				setdesignationsDataItems(formattedDesignationsData);
			} else if (activeTab === "teams") {
				const formattedTeamsData = selectedDataRecord.items.map(
					(item: any) => ({
						id: item.id,
						teams: item.companyDesignId,
						fromDate:
							item.fromDate && item.fromDate !== "" && item.fromDate !== null
								? new Date(item.fromDate)
								: null,
						toDate:
							item.toDate && item.toDate !== "" && item.toDate !== null
								? new Date(item.toDate)
								: null,
						notes: item.notes,
					})
				);
				setteamsDataItems(formattedTeamsData);
			} else if (activeTab === "locations") {
				const formattedLocationsData = selectedDataRecord.items.map(
					(item: any) => ({
						id: item.id,
						locations: item.companyDesignId,
						fromDate:
							item.fromDate && item.fromDate !== "" && item.fromDate !== null
								? new Date(item.fromDate)
								: null,
						toDate:
							item.toDate && item.toDate !== "" && item.toDate !== null
								? new Date(item.toDate)
								: null,
						notes: item.notes,
					})
				);
				setlocationsDataItems(formattedLocationsData);
			} else if (activeTab === "expenseCategory") {
				const formattedExpenseCategoryData = selectedDataRecord.items.map(
					(item: any) => ({
						id: item.id,
						expenseCategory: item.companyDesignId,
						fromDate:
							item.fromDate && item.fromDate !== "" && item.fromDate !== null
								? new Date(item.fromDate)
								: null,
						toDate:
							item.toDate && item.toDate !== "" && item.toDate !== null
								? new Date(item.toDate)
								: null,
						notes: item.notes,
					})
				);
				setexpenseCategoryDataItems(formattedExpenseCategoryData);
			}
			// setSelectedEmployeeId(selectedDataRecord.employeeId);
			// setSelectedEmployeeLabel(selectedDataRecord.employeeName);
		}
	}, [selectedDataRecord]);

	const { isPending: isDeleting, mutate: deleteAssignEmployeeById } = useMutation({
		mutationFn: EmployeeService.delAssignEmployee,

		onSuccess: (res: string | IServerError | IResponse) => {
			if (typeof res === "string") {
				// remove the cache of the Departments fields since we just added a new field.
				setSnackbarData({
					open: true,
					message: "Success",
					severity: "success",
				});
				// formMethods.reset();
				// let path = `/employee/assignment`;
				// navigate(path);
			} else {
				setSnackbarData({
					open: true,
					message: "Something went wrong, try again later!",
					severity: "error",
				});
			}
			return queryClient.invalidateQueries({
				queryKey: [SINGLE_RECORD_DATA_QUERY_KEY],
			});
		},
		onError: () => {
			// TODO: customize the toast message based on the response
			setSnackbarData({
				open: true,
				message: "Something went wrong, try again later!",
				severity: "error",
			});
		},
	});


	const deleteEmployeeField = () => {
		if (singleDelete) {
			setSingleDelete(false);
			let delPayload = {
				id: deletedRowId && deletedRowId,
				selectedEmployeeId: selectedEmployeeId,
				clientId: clientId,
				designedLabel:
					activeTabIndex === 0
						? 200
						: activeTabIndex === 1
							? 300
							: activeTabIndex === 2
								? 400
								: activeTabIndex === 3
									? 100
									: 500,
				navigateToLogout: navigateToLogout,
			};
			deleteAssignEmployeeById(delPayload);
			setDialogOpen(false);
		}
	};

	const onDeleteClicked = (params: any) => {
		setDeletedRowId(params.id)
		console.log('paramasssssssssssss', params)
		setDialogOpen(true);
		setSingleDelete(true);
		if (selectedDataRecord) {
			setSelectedEmployeeId(selectedDataRecord.employeeId);
		}
		selectedEmployeeId(params.id); // check later id is correct or not 
	};

	const expandedLabels = ["Employee", "Assignment"];
	const expandedEmployeeAssignmentsetupItem = "Assignment"; // Special case for "Setup" under "City Tax"
	const enhanceData = (data: any[], parentLabel?: string): any[] => {
		return data.map((item) => {
			let isExpanded = expandedLabels.includes(item.label);
			if (
				parentLabel === "Assignment" &&
				item.label === expandedEmployeeAssignmentsetupItem
			) {
				isExpanded = true;
			}
			const enhancedItem = {
				...item,
				expanded: item.items ? isExpanded : false,
				items: item.items ? enhanceData(item.items, item.label) : undefined,
				path: item.label === expandedEmployeeAssignmentsetupItem && "/employee/assignment",
			};
			return enhancedItem;
		});
	};

	const onSnackbarClosed = (
		_event: React.SyntheticEvent | Event,
		reason?: string
	) => {
		if (reason === "clickaway") {
			return;
		}
		setSnackbarData(INITIAL_SNACKBAR_DATA);
	};

	const onResetClicked = () => {
		setSnackbarData({
			open: true,
			message: "Success",
			severity: "success",
		});
		formMethods.reset();
		// setDepartmentsData(departmentsInitialData);
		setdepartmentsDataItems(departmentsInitialData);
		setdesignationsDataItems(designationsInitialData);
		setteamsDataItems(teamsInitialData);
		setlocationsDataItems(locationsInitialData);
		setexpenseCategoryDataItems(expenseCategoryInitialData);
		setSelectedEmployeeId(undefined);

		let path = `/employee/assignment`;
		navigate(path);
	};

	const onCloseHandler = () => {
		setDialogOpen(false);
	};


	const onTabChange = (e: any) => {
		setActiveTabIndex(e.index);
		if (e.originalEvent?.target) {
			setActiveTabLabel(e.originalEvent.target.textContent);
			queryClient.invalidateQueries({
				queryKey: [
					SINGLE_RECORD_DATA_QUERY_KEY,
					selectedEmployeeId,
					clientId,
					activeTab,
				],
			});
			setIsPendingData(true);
			setTimeout(() => {
				setIsPendingData(false);
			}, 1000);
		} else {
			setActiveTabLabel("Departments");
		}
	};
	const onDividerButtonClickHandler = () => {
		setSidePanelsVisibility((prevButtonState: any) => !prevButtonState);
	};

	useEffect(() => {
		dispatch(
			setSelectedActivityLogActions({
				entityId1: "",
				entityId2: "",
				entityId3: "",
				screenName: EMPLOYEE_STATUS_SETUP_SCREEN_SLUG,
				accountantName: "",
				activityType:
					"activity_type=create&activity_type=updated&activity_type=delete",
				activityLogVisibility: true,
			})
		);
		dispatch(setSelectedStickyNavBar({ isSticky: true }));
		if (drawerMenuOptions && drawerMenuOptions.length > 0) {
			const enhancedData = enhanceData(drawerMenuOptions);
			dispatch(setSelectedDrawerOptionsMenu({ menu: enhancedData }));
		}
	}, [drawerMenuOptions]);

	return (
		<Grid
		// sx={{ pb: "5rem", "& .MuiAppBar-root": { zIndex: 2, top: "65px" } }}
		>
			<BackdropCircularProgress
				open={
					isSubmitting ||
					isPendingEmployeeDDL ||
					isPendingDepartmentDDL ||
					isPending ||
					isPendingData ||
					isLoadingData ||
					isDeleting
				}
				testId="comapny Setup"
			/>
			<DeleteConfirmationDialog
				open={openDialog}
				deleteActionHandler={deleteEmployeeField}
				cancelActionHandler={onCloseHandler}
				testId="accountant-confirmation-dialog"
			/>

			<Grid container size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
				<Grid
					// item
					// xs={sidePanelsVisibility ? 8 : 10}
					// sm={sidePanelsVisibility ? 8 : 10.8}
					// md={sidePanelsVisibility ? 9.4 : 11.2}
					// lg={sidePanelsVisibility ? 9.5 : 11.6}
					// xl={sidePanelsVisibility ? 9.7 : 11.7}
					size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
					sx={{ "& .MuiGrid-container": { marginTop: 0 } }}
				>
					<FormProvider {...formMethods}>
						<form onSubmit={formMethods.handleSubmit(onSubmit)}>
							<Grid container size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
								<Grid
									size={{ xs: 12, sm: 12, md: 8, lg: 8, xl: 8 }}
									sx={{ marginTop: "16px" }}
								>
									<SingleColumnLayout
										children={
											<StandardPanel
												title="Employee Assignment"
												testId={`accountant-bank-setup`}
												showTitle={false}
											>
												<TabView
													activeIndex={activeTabIndex}
													onTabChange={onTabChange}

												>
													<TabPanel header="Departments">
														<DepartmentsTabsPanel
															departmentsUpdatedData={(data: any) =>
																setdepartmentsUpdatedData(data)
															}
															departmentsDataItems={departmentsDataItems}
															departmentsDDLData={departmentsDDLItems}
															TabTableheaderColumns={TabTableheaderColumns}
															selectedEmployeeLabel={selectedEmployeeLabel}
															onRowDeleteClicked={(data: any) => onDeleteClicked(data)}
														/>
													</TabPanel>
													<TabPanel header="Designations">
														<DesignationsTabsPanel
															designationsUpdatedData={(data: any) =>
																setdesignationsUpdatedData(data)
															}
															designationsDataItems={designationsDataItems}
															TabTableheaderColumns={TabTableheaderColumns}
															selectedEmployeeLabel={selectedEmployeeLabel}
															onRowDeleteClicked={(data: any) => onDeleteClicked(data)}
														/>
													</TabPanel>
													<TabPanel header="Teams">
														<TeamsTabsPanel
															teamsUpdatedData={(data: any) =>
																setteamsUpdatedData(data)
															}
															teamsDataItems={teamsDataItems}
															TabTableheaderColumns={TabTableheaderColumns}
															selectedEmployeeLabel={selectedEmployeeLabel}
															onRowDeleteClicked={(data: any) => onDeleteClicked(data)}
														/>
													</TabPanel>
													<TabPanel header="Locations">
														<LocationsTabsPanel
															locationsUpdatedData={(data: any) =>
																setlocationsUpdatedData(data)
															}
															locationsDataItems={locationsDataItems}
															TabTableheaderColumns={TabTableheaderColumns}
															selectedEmployeeLabel={selectedEmployeeLabel}
															onRowDeleteClicked={(data: any) => onDeleteClicked(data)}
														/>
													</TabPanel>
													<TabPanel header="Expense Category">
														<ExpenseCategoryTabsPanel
															expenseCategoryUpdatedData={(data: any) =>
																setexpenseCategoryUpdatedData(data)
															}
															expenseCategoryDataItems={
																expenseCategoryDataItems
															}
															TabTableheaderColumns={TabTableheaderColumns}
															selectedEmployeeLabel={selectedEmployeeLabel}
															onRowDeleteClicked={(data: any) => onDeleteClicked(data)}
														/>
													</TabPanel>
												</TabView>
											</StandardPanel>
										}
										toolbar={
											<EmployeeAssignemntToolbar
												onResetClicked={onResetClicked}
												// onDeleteClicked={onDeleteClicked}
												isSubmitting={false}
												id={id}
											/>
										}
										testId="form-layout"
										toolbarPosition="bottom"
										showFullDiaplay={true}
									/>
								</Grid>
								<Grid size={{ xs: 0, sm: 0, md: 1, lg: 1, xl: 1 }}></Grid>
								<Grid
									size={{ xs: 12, sm: 12, md: 3, lg: 3, xl: 3 }}
									sx={{ marginTop: "16px" }}
								>
									<DDLDataTable
										rows={upadtedEmployeeAssignmentItems}
										// onRowEditClicked={onRowEditClicked}
										// onRowDeleteClicked={onRowDeleteClicked}
										// onRowArchiveClicked={onArchiveClicked}
										showDeleteIcon={false}
										isLoading={false}
										showPaginator={false}
										totalRecords={0}
										initialPageSize={INITIAL_PAGE_SIZE}
										rowsPerPageOptions={ROWS_PER_PAGE_PER_OPTIONS}
										// onRequestParamsChange={onRequestParamsChange}
										tableScrollHeight={"60vh"}
										selectedId={selectedDataRecord && id && selectedDataRecord.employeeId}
									/>
								</Grid>
							</Grid>
						</form>
					</FormProvider>
				</Grid>
			</Grid>

			<EnhancedSnackbar
				message={snackbarData.message}
				onCloseHandler={onSnackbarClosed}
				severity={snackbarData.severity}
				testId={"accountant-snackbar"}
				open={snackbarData.open}
			/>
		</Grid>
	);
};
